<resource-attributes [resource]="linkType$ | async" [attributesResourceType]="linkTypeType"></resource-attributes>
